import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'qumra-checkbox-button',
  styleUrl: 'qumra-checkbox-button.css',
  shadow: true,
})
export class QumraCheckboxButton {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
